import { ApiClient } from '@k2/common/backend/api-client';
import { AssignmentIdentity } from '@k2/common/entities-state/types';

export class AssignmentHhgEndpoint {
  constructor(private api: ApiClient) {

  }

  // TRANSACTIONS
  // Invoices Recurring
  fetchNewTransactionsInvoicesRecurringForm = (
    { clientId, assignmentId }: AssignmentIdentity,
    serviceId: number
  ) => {
    return this.api.getWithoutCache(
      `/clients/${clientId}/assignment/${assignmentId}/service/${serviceId}/transactions/invoices/recurring/new`
    );
  };

  createTransactionsInvoicesRecurring = (
    { clientId, assignmentId }: AssignmentIdentity,
    serviceId: number,
    data: any
  ) => {
    return this.api.post(
      `/clients/${clientId}/assignment/${assignmentId}/service/${serviceId}/transactions/invoices/recurring`,
      data
    );
  };

  fetchTransactionsInvoicesRecurringForm = (
    { clientId, assignmentId }: AssignmentIdentity,
    transactionId: string,
    serviceId: number
  ) => {
    return this.api.getWithoutCache(
      `/clients/${clientId}/assignment/${assignmentId}/service/${serviceId}/transactions/invoices/recurring/${transactionId}`
    );
  };

  updateTransactionsInvoicesRecurring = (
    { clientId, assignmentId }: AssignmentIdentity,
    transactionId: string,
    serviceId: number,
    data: any
  ) => {
    return this.api.patch(
      `/clients/${clientId}/assignment/${assignmentId}/service/${serviceId}/transactions/invoices/recurring/${transactionId}`,
      data
    );
  };

  // Purchases Recurring
  fetchTransactionsPurchasesRecurringForm = (
    { clientId, assignmentId }: AssignmentIdentity,
    transactionId: string,
    serviceId: number
  ) => {
    return this.api.getWithoutCache(
      `/clients/${clientId}/assignment/${assignmentId}/service/${serviceId}/transactions/purchases/recurring/${transactionId}`
    );
  };

  // Purchases Recurring PO
  updateTransactionsPurchasesRecurring = (
    { clientId, assignmentId }: AssignmentIdentity,
    transactionId: string,
    serviceId: number,
    data: any
  ) => {
    return this.api.patch(
      `/clients/${clientId}/assignment/${assignmentId}/service/${serviceId}/transactions/purchases/recurring/${transactionId}`,
      data
    );
  };
}
